module.exports = __webpack_public_path__ + "img/asu_careercatalyst_logo.4e3e7ed2.png";